import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserdataService } from '../../../../service/userdata.service';
import { AppdataService } from '../../../../service/appdata.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AvatarEditComponent } from '../../../home-header/user-avatar/avatar-edit/avatar-edit.component';
import { smallDialogWidth } from '../../../../../environments/environment';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from '../../../../service/company.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DeletionService } from '../../../../service/deletion.service';
import { DeleteCompanyComponent } from './delete-company/delete-company.component';
import { SnackService } from '../../../../service/snack.service';

@Component({
    selector: 'app-basic-settings',
    standalone: false,

    templateUrl: './basic-settings.component.html',
    styleUrl: './basic-settings.component.scss'
})
export class BasicSettingsComponent implements OnInit, OnDestroy {
    user: any;
    industryOptions: any[] = [];
    roleOptions: any[] = [];
    intentionRoleOptions: any[] = [];
    languageOptions: any[] = [];
    routeQueryParams$: Subscription;
    basicForm: FormGroup;
    companyOwner: boolean = false;

    constructor(
        private userService: UserdataService,
        private appData: AppdataService,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private compService: CompanyService,
        private route: ActivatedRoute,
        private router: Router,
        private deletionService: DeletionService,
        private snack: SnackService,
    ) {
        this.user = this.userService.data.getValue();

        this.basicForm = this.fb.group({
            prename: [this.user?.prename],
            lastname: [this.user.lastname],
            intentionRoleId: [this.user?.intentionRoleId],
            lang: [this.user?.lang],
        });

        this.basicForm.valueChanges.subscribe((data) => {
            this.saveChanges('USER');
        });

        this.routeQueryParams$ = this.route.queryParams.subscribe((params) => {
            if (params['edit-avatar']) {
                this.editAvatar();
            }
        });

        if (this.user.role.includes('LICENSE_OWNER')) {
            this.companyOwner = true;
        }
    }

    ngOnInit(): void {
        this.loadData();
    }

    ngOnDestroy(): void {
        this.routeQueryParams$.unsubscribe();
    }

    async saveChanges(type: string) {
        let result = false;
        result = await this.userService.updateUserDataOnServer(this.basicForm.value);
        if (result == true) {
            this.user.prename = this.basicForm.value.prename;
            this.user.lastname = this.basicForm.value.lastname;
            this.user.lang = this.basicForm.value.lang;
            this.user.intentionRoleId = this.basicForm.value.intentionRoleId;
            this.userService.updateUserData(this.user);
        }
    }
    changeEmailShow() {
        const nextEmailRaw = prompt('Please enter your new email address', this.user?.email || '');
        if (nextEmailRaw === null) {
            return;
        }

        const nextEmail = nextEmailRaw.trim().toLowerCase();
        const emailReg = /\S+@\S+\.\S+/;

        if (!emailReg.test(nextEmail)) {
            this.snack.errorText('Please enter a valid email address.');
            return;
        }

        if (nextEmail === this.user?.email) {
            this.snack.info({
                headline: 'No change detected',
                text: 'Your email address is already set to this value.',
            });
            return;
        }

        this.userService.changeEmailAddress(nextEmail).then((result) => {
            if (!result) {
                return;
            }

            this.user.email = nextEmail;
            this.userService.updateUserData(this.user);
            this.snack.success({
                msg: {
                    headline: 'Success',
                    text: 'Your email address was updated.',
                }
            });
        });
    }
    changePasswordShow() {
        this.dialog.open(ChangePasswordComponent, {
            panelClass: 'small-dialog',
        })
    }
    editAvatar() {
        let result = this.dialog.open(AvatarEditComponent, {
            width: smallDialogWidth,
            panelClass: 'avatar-edit-dialog',
            data: this.user
        });
        result.afterClosed().subscribe((data) => {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { 'edit-avatar': null },
                queryParamsHandling: 'merge'
            });
        });
    }
    async changeCompanyData(data: any) {
        const industryId = data?.industry || data?.industryId || this.user?.companyData?.industryId;
        let result = await this.compService.updateCompanyMetaData(data.name, industryId, data.mission, data.webpage);
        if (result === false) {
            return;
        }
        this.user.companyData = {
            ...this.user.companyData,
            ...data,
            industryId,
            industry: industryId,
        };
        this.userService.updateUserData(this.user);
    }
    async loadData() {
        const userLicense = await this.user.licenseData?.find((license: any) => license.userId === this.user.id);
        this.roleOptions = this.appData.roles?.filter((role) => role.level <= userLicense?.maxRoleLevel);
        this.languageOptions = this.appData.systemLanguages;
        this.intentionRoleOptions = this.appData.intentionRoles;
    }
    async deleteAccount() {
        let c = confirm("Are you sure you want to delete this account and all associated data?")
        if (!c) return;
        let result = await this.deletionService.deleteUser();
    }

    async deleteCompany() {
        console.log(this.user)
        let dia = await this.dialog.open(DeleteCompanyComponent, {
            panelClass: 'small-dialog'
        })
        //let result = await this.deletionService.deleteCompany();
    }
}

